import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Button from '../Button';

export default () => (
  <>
    <Heading level={1}>Secondary Button</Heading>
    <Spacer size={16} />
    <Text>
      Setting <Code>{'type="secondary"'}</Code> on the{' '}
      <Code>{'<Button />'}</Code> component will render a secondary button.
    </Text>
    <Spacer size={16} />
    <Text>
      Secondary button's border/background/text colors are always the same
      regardless of the current user's competency level.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Button type="secondary">Label</Button>
        <Spacer size={6} />
        <Text>Active</Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Button type="secondary" disabled={true}>
          Label
        </Button>
        <Spacer size={6} />
        <Code>{'disabled={true}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
